import { ErrorStateProps } from '@leagueplatform/web-common-components';
import { useIntl } from '@leagueplatform/locales';
import DEFAULT_API_ERROR_ICON from 'assets/error-subtle-icon.svg';
import { IneligibleUserErrorBody } from './ineligible-user-error-body.component';

export enum ERROR_TYPES {
  AUTH_ERROR = 'auth_error',
  API_ERROR = 'api_error',
  INELIGIBLE_ERROR = 'ineligible_error',
}

export type ErrorContentProps = {
  errorType?: ERROR_TYPES;
  buttonText?: string;
  headingString?: string;
  bodyString?: string;
  buttonAction?: () => void;
  error?: ErrorStateProps['error'];
};

type ErrorBody = {
  heading: string;
  body: React.ReactNode;
  buttonText?: string;
  buttonAction?: () => void;
  iconSrc?: string;
};

export const useErrorContent = ({
  errorType = ERROR_TYPES.API_ERROR,
  buttonText,
  headingString,
  bodyString,
  buttonAction,
  error = null,
}: ErrorContentProps) => {
  const { formatMessage } = useIntl();

  const ErrorMessages: Record<ERROR_TYPES, ErrorBody> = {
    [ERROR_TYPES.API_ERROR]: {
      heading: formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' }),
      body: formatMessage({ id: 'STR_ERROR_STATE_BODY_API' }),
      buttonText: formatMessage({ id: 'STR_RELOAD' }),
      buttonAction: () => window.location.reload(),
      iconSrc: DEFAULT_API_ERROR_ICON,
    },
    [ERROR_TYPES.AUTH_ERROR]: {
      heading: formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' }),
      body: formatMessage({ id: 'STR_ERROR_STATE_BODY_LOGIN_ERROR' }),
      buttonText: formatMessage({ id: 'STR_TRY_AGAIN' }),
      iconSrc: DEFAULT_API_ERROR_ICON,
    },
    [ERROR_TYPES.INELIGIBLE_ERROR]: {
      heading: formatMessage({ id: 'STR_ERROR_STATE_HEADING_INELIGIBLE' }),
      body: <IneligibleUserErrorBody />,
      iconSrc: DEFAULT_API_ERROR_ICON,
    },
  };

  let errorContentData: ErrorStateProps = {
    headingString: headingString || ErrorMessages[errorType].heading,
    bodyString: bodyString || ErrorMessages[errorType].body,
    error,
  };

  const btnText = buttonText || ErrorMessages[errorType].buttonText;
  const onBtnClick = buttonAction || ErrorMessages[errorType].buttonAction;

  if (btnText && onBtnClick) {
    errorContentData = {
      ...errorContentData,
      buttonText: btnText,
      onButtonClick: onBtnClick,
      imageSrc: ErrorMessages[errorType].iconSrc,
    };
  }

  return errorContentData;
};
